module.exports = __webpack_public_path__ + "static/media/ANM019-Cameron-Shafii02.ce099f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ANM019-Cameron-Shafii02.jpg
// module id = 95
// module chunks = 0